import {
  BillingDashboardOutput,
  BillingExpensesCategoriesOutput,
  BillingPlacesOutput,
  BillingProductsOutput,
  BillingQueryParams,
  BillingsMonthlyOutput,
  BillingsProductsProfitOutput,
  BillingsSalesDailyOutput,
} from "@/interfaces/billing";
import { BaseService } from "./BaseService";

export class BillingService extends BaseService<
  unknown,
  unknown,
  BillingQueryParams
> {
  constructor() {
    super();
    this.path = "billings";
  }

  public async getDashboard(
    queryParams?: BillingQueryParams,
    options: RequestInit = {}
  ): Promise<BillingDashboardOutput> {
    return (await this.request(`${this.path}/dashboard`, {
      ...options,
      queryParams,
      method: "GET",
    })) as BillingDashboardOutput;
  }

  public async getProducts(
    queryParams?: BillingQueryParams,
    options: RequestInit = {}
  ): Promise<BillingProductsOutput[]> {
    return (await this.request(`${this.path}/products`, {
      ...options,
      queryParams,
      method: "GET",
    })) as BillingProductsOutput[];
  }

  public async getExpensesCategories(
    queryParams?: BillingQueryParams,
    options: RequestInit = {}
  ): Promise<BillingExpensesCategoriesOutput[]> {
    return (await this.request(`${this.path}/expenses/categories`, {
      ...options,
      queryParams,
      method: "GET",
    })) as BillingExpensesCategoriesOutput[];
  }

  public async getMonthly(
    queryParams?: BillingQueryParams,
    options: RequestInit = {}
  ): Promise<BillingsMonthlyOutput[]> {
    return (await this.request(`${this.path}/monthly`, {
      ...options,
      queryParams,
      method: "GET",
    })) as BillingsMonthlyOutput[];
  }

  public async getPlaces(
    queryParams?: BillingQueryParams,
    options: RequestInit = {}
  ): Promise<BillingPlacesOutput[]> {
    return (await this.request(`${this.path}/places`, {
      ...options,
      queryParams,
      method: "GET",
    })) as BillingPlacesOutput[];
  }

  public async getProductsProfit(
    queryParams?: BillingQueryParams,
    options: RequestInit = {}
  ): Promise<BillingsProductsProfitOutput[]> {
    return (await this.request(`${this.path}/products/profit`, {
      ...options,
      queryParams,
      method: "GET",
    })) as BillingsProductsProfitOutput[];
  }

  public async getSalesDaily(
    queryParams?: BillingQueryParams,
    options: RequestInit = {}
  ): Promise<BillingsSalesDailyOutput[]> {
    return (await this.request(`${this.path}/sales/daily`, {
      ...options,
      queryParams,
      method: "GET",
    })) as BillingsSalesDailyOutput[];
  }
}
